// extracted by mini-css-extract-plugin
export var header = "_sw-1";
export var maskBottom = "_sw-6";
export var maskMiddle = "_sw-7";
export var maskTop = "_sw-5";
export var root = "_sw-0";
export var scrollDownButton = "_sw-3";
export var scrollDownButtonHidden = "_sw-4";
export var viewport = "_sw-2";